module.exports = __webpack_public_path__ + "img/fangan1.817524df.png";